import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["focusLoop"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react';
import { useControlledState } from 'ariakit-utils/hooks';
import { useStorePublisher } from 'ariakit-utils/store';
import { useCompositeState } from '../composite/composite-state.js';
/**
 * Provides state for the `Radio` components.
 * @example
 * ```jsx
 * const radio = useRadioState();
 * <RadioGroup state={radio}>
 *   <Radio value="Apple" />
 *   <Radio value="Orange" />
 * </RadioGroup>
 * ```
 */

function useRadioState(_temp) {
  var _props$defaultValue;

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$focusLoop = _ref.focusLoop,
      focusLoop = _ref$focusLoop === void 0 ? true : _ref$focusLoop,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useControlledState = useControlledState((_props$defaultValue = props.defaultValue) != null ? _props$defaultValue : null, props.value, props.setValue),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      value = _useControlledState2[0],
      setValue = _useControlledState2[1];

  var composite = useCompositeState(_objectSpread({
    focusLoop: focusLoop
  }, props));
  var state = useMemo(function () {
    return _objectSpread(_objectSpread({}, composite), {}, {
      value: value,
      setValue: setValue
    });
  }, [composite, value, setValue]);
  return useStorePublisher(state);
}

export { useRadioState };